export default __webpack_public_path__ + "static/media/will_thumb.69bf849a.jpg";